import { FactoryArg } from "imask";
import { MaskedInputProps, MaskedInputControlledProps, MaskedInput, MaskedInputControlled } from "./MaskedInput";

const mask = "+1 (000) 000-0000";
const validationExp = /\+1 \(\d{3}\) \d{3}-\d{4}/;
const placeholder = "+1 (555) 555-5555";
const validationMessage = "Invalid phone number";

export const MaskedPhoneInput = <Opts extends FactoryArg>(props: Partial<MaskedInputProps<Opts>>) => {
    return <MaskedInput type="tel" placeholder={placeholder} mask={mask} {...props} />;
};

export const MaskedPhoneInputControlled = <Opts extends FactoryArg>({
    name,
    rules,
    invalidMessage,
    ...props
}: { invalidMessage?: string; name: string } & Partial<MaskedInputControlledProps<Opts>>) => {
    return (
        <MaskedInputControlled
            name={name}
            type="tel"
            placeholder={placeholder}
            mask={mask}
            rules={{ pattern: { value: validationExp, message: invalidMessage || validationMessage }, ...rules }}
            {...props}
        />
    );
};
